var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 3.66663H16.4998C16.9861 3.66663 17.4524 3.85978 17.7962 4.2036C18.14 4.54741 18.3332 5.01373 18.3332 5.49996V18.3333C18.3332 18.8195 18.14 19.2858 17.7962 19.6297C17.4524 19.9735 16.9861 20.1666 16.4998 20.1666H5.49984C5.01361 20.1666 4.54729 19.9735 4.20347 19.6297C3.85966 19.2858 3.6665 18.8195 3.6665 18.3333V5.49996C3.6665 5.01373 3.85966 4.54741 4.20347 4.2036C4.54729 3.85978 5.01361 3.66663 5.49984 3.66663H7.33317",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 1.83337H8.25016C7.7439 1.83337 7.3335 2.24378 7.3335 2.75004V4.58337C7.3335 5.08963 7.7439 5.50004 8.25016 5.50004H13.7502C14.2564 5.50004 14.6668 5.08963 14.6668 4.58337V2.75004C14.6668 2.24378 14.2564 1.83337 13.7502 1.83337Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIcon);
export default __webpack_public_path__ + "static/media/clipboardIcon.18c4eb65f239dfe17b41bb8f2c73b176.svg";
export { ForwardRef as ReactComponent };